import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import './style.scss';

export default class Iframe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.shortname === 'footasylum' ? require('./data/footasylum.json') : [],
            terms: false,
        };
    }
    handleAcceptTerms = () => {
        if (this.props.shortname === 'footasylum') {
            this.setState({ terms: !this.state.terms });
        }
    };
    render() {
        const { shortname } = this.props;
        const { data, terms } = this.state;
        return (
            <Fragment>
                {!terms && shortname === 'footasylum' ? (
                    <div className="disclaimer-overlay">
                        <div className="disclaimer">
                            <center>
                                <p className="bold">
                                    Please read and confirm that you accept the following terms and
                                    conditions
                                    <br />
                                    <br />
                                    IMPORTANT NOTICE
                                    <br />
                                    <br />
                                    Please read this notice carefully – it applies to all persons
                                    who view this section of the website
                                </p>
                            </center>
                            <p className="bold">
                                RECOMMENDED CASH OFFER (THE "OFFER") BY JD SPORTS FASHION PLC ("JD")
                                FOR THE ENTIRE ISSUED SHARE CAPITAL OF FOOTASYLUM PLC ("FA") NOT
                                ALREADY OWNED BY JD ANNOUNCED ON 18 MARCH 2019.
                            </p>
                            <p className="bold">
                                THIS SECTION OF THE WEBSITE (THE "MICRO-SITE") CONTAINS
                                ANNOUNCEMENTS, DOCUMENTS AND INFORMATION (THE "INFORMATION")
                                PUBLISHED BY JD AND/OR FA RELATING TO THE OFFER IN COMPLIANCE WITH
                                THE UK CITY CODE ON TAKEOVERS AND MERGERS (THE "CODE"). THE
                                INFORMATION IS BEING MADE AVAILABLE IN GOOD FAITH AND FOR
                                INFORMATION PURPOSES ONLY, AND ITS AVAILABILITY IS SUBJECT TO THE
                                TERMS AND CONDITIONS SET OUT BELOW.
                            </p>
                            <p className="bold">Access to information relating to the Offer</p>
                            <p>
                                Please read this notice carefully – it applies to all persons who
                                view this Micro-site and, depending upon who you are and where you
                                live, it may affect your rights. This notice and the information
                                contained herein may be altered or updated from time to time, and
                                should be read carefully each time you visit this Micro-site.
                            </p>
                            <p>
                                For regulatory reasons, JD has to ensure you are aware of the
                                appropriate regulations for the country which you are in. To allow
                                you to view Information relating to the Offer, you are required to
                                read the following and then, if you are able to agree, press "I
                                agree" below. If you are unable to agree, you should press "I
                                disagree" and you will not be able to view Information relating to
                                the Offer.
                            </p>
                            <p className="bold">Overseas Persons</p>
                            <p>
                                The Information is not for publication or distribution, directly or
                                indirectly, in or into the United States, Japan, South Africa or
                                Australia or any other jurisdiction where local laws or regulations
                                may result in a significant risk of civil, regulatory or criminal
                                exposure for JD or FA or would otherwise violate the law of that
                                jurisdiction (a "Restricted Jurisdiction"). Accordingly, viewing the
                                Information may not be lawful if you are resident or located in a
                                Restricted Jurisdiction. In certain jurisdictions, including
                                Restricted Jurisdictions, only certain categories of person may be
                                allowed to view such materials. Any person resident or located
                                outside the United Kingdom who wishes to view these materials must
                                first satisfy themselves that they are not subject to any local
                                requirements that prohibit or restrict them from doing so.
                            </p>
                            <p>
                                If you are not resident or located in a Restricted Jurisdiction, you
                                may access the Information but you are responsible for first
                                satisfying yourself as to the full observance of the laws and
                                regulatory requirements of your jurisdiction.
                            </p>
                            <p>
                                Similarly, the Information is not being, and must not be, released
                                or otherwise forwarded, distributed or sent in or into a Restricted
                                Jurisdiction and persons receiving such Information (including
                                custodians, nominees and trustees) must not distribute or send it
                                in, into or from a Restricted Jurisdiction.
                            </p>
                            <p className="bold">
                                By clicking "I agree" below, you represent that you are not a
                                national of, or resident in, a Restricted Jurisdiction and that JD
                                is lawfully entitled to make the content of any Information
                                available to you under applicable securities laws. If you are unable
                                to give this representation, do not view the Information.
                            </p>
                            <p className="bold">
                                If you are not permitted to view the Information or are in any doubt
                                as to whether you are permitted to do so, please exit this
                                Micro-site by clicking on the "I disagree" box below and seek
                                independent advice.
                            </p>
                            <p className="bold">
                                To the fullest extent permitted by applicable law, JD, FA and their
                                respective directors, employees, agents and advisers, disclaim any
                                and all responsibility or liability for the violation of such
                                restrictions by any person.
                            </p>
                            <p>
                                Various contents of this Micro-site have been prepared in accordance
                                with English law and the Code, and, accordingly, the information
                                disclosed may not be the same as that which would have been made
                                available in jurisdictions outside the United Kingdom.
                            </p>
                            <p className="bold">Forward-looking statements</p>
                            <p>
                                The Information set out herein contains certain forward-looking
                                statements with respect to the financial condition, results of
                                operations and business of JD and FA and certain plans and
                                objectives of the boards of directors JD and FA. These
                                forward-looking statements can be identified by the fact that they
                                do not relate to historical or current facts. Without limitation,
                                any statements preceded or followed by or that include words such as
                                "target", "plan", "believe", "expect", "anticipate", "estimate",
                                "intend", "plan", "goal", "will", "may", "should", "would", "could"
                                or words or terms of similar substance or the negative of such words
                                are forward-looking statements. These statements are based on
                                assumptions and assessments made by the boards of directors of JD or
                                FA in light of their experience and their perception of historical
                                trends, current conditions, expected future developments and other
                                factors they believe appropriate. By their nature, forward-looking
                                statements involve risk and uncertainty and the factors described in
                                the context of such forward-looking statements could cause actual
                                results and developments to differ materially from those expressed
                                in or implied by such forward-looking statements. Readers are
                                cautioned not to place undue reliance on these forward-looking
                                statements. In any event, these statements speak only as of the date
                                on which they are made, and, subject to compliance with the Code and
                                applicable law, JD does not intend, nor undertakes any obligation,
                                to update or revise any such statement except as required by
                                applicable law or regulation.
                            </p>
                            <p className="bold">Basis of access to Information</p>
                            <p>
                                Access to the electronic version of any Information relating to the
                                Offer is being made available by JD in good faith and for
                                information purposes only. Any person seeking access to the
                                Information on this Micro-site represents and warrants to JD that he
                                or she is doing so for information purposes only. Making Information
                                relating to the Offer available in electronic format does not
                                constitute an invitation or offer to sell or the solicitation of an
                                offer to buy, or subscribe for, shares in either JD or FA nor does
                                it constitute an invitation, solicitation or recommendation by JD,
                                FA or any other person to any other person to take any other action
                                in relation to the Offer.
                            </p>
                            <p>
                                You should not forward, transmit or show the information contained
                                in this Micro-site to any person. In particular, you should not
                                forward or transmit the information contained in this Micro-site in
                                or into any jurisdiction any Restricted Jurisdiction.
                            </p>
                            <p>
                                If you are in any doubt about the contents of this Micro-site or,
                                where applicable, the action you should take, you should seek your
                                own financial advice from an independent financial adviser
                                authorised and regulated in the United Kingdom by the Financial
                                Conduct Authority or, if you are located outside the United Kingdom,
                                from an appropriately authorised independent financial adviser. Any
                                actions or decisions required by FA's shareholders in connection
                                with the Offer should only be made on the basis of the information
                                set out in documents sent to or made available to FA's shareholders.
                            </p>
                            <p>
                                This notice, and any non-contractual obligations arising out of or
                                in connection with this notice, shall be governed by and construed
                                in accordance with English law.
                            </p>
                            <p className="bold">Responsibility</p>
                            <p>
                                Subject to any continuing obligations under applicable law or any
                                relevant regulatory requirements, JD expressly disclaims any
                                obligation to disseminate, after the date of the posting of any
                                document or announcement on this Micro-site, any updates or
                                revisions to any statements in such documents or announcements in
                                relation to the Offer to reflect any change in expectations or
                                events, conditions or circumstances on which any such statements are
                                based.
                            </p>
                            <p>
                                In relation to any materials contained on the Micro-site, the only
                                responsibility accepted by the directors of JD ("Responsible
                                Persons") is for the correctness and fairness of their reproduction
                                or presentation unless the responsibility statement in any relevant
                                document expressly provides otherwise.
                            </p>
                            <p>
                                The Responsible Persons are responsible in the terms set out above
                                solely for the relevant materials contained on the Micro-site and
                                not for any other information on the website which you may visit on
                                leaving the Micro-site.
                            </p>
                            <p>
                                None of the Responsible Persons, JD or JD's employees, agents or
                                advisers have reviewed and none of them is responsible for, or
                                accepts any liability in respect of, any information on any other
                                website that may be linked to this Micro-site website by a third
                                party.
                            </p>
                            <p className="bold">
                                Confirmation of understanding and acceptance of disclaimer
                            </p>
                            <p>
                                By clicking the link below labelled "I agree" you represent and
                                warrant that:
                            </p>
                            <ol>
                                <li>
                                    you have read and understood the terms set out above and which
                                    you understand may affect your rights and responsibilities;
                                </li>
                                <li>
                                    you are not (nor do you act on behalf of someone who is)
                                    resident in any country or jurisdiction that renders the
                                    accessing of the Micro-site illegal or otherwise resident in any
                                    Restricted Jurisdiction;
                                </li>
                                <li>
                                    you are lawfully entitled to access the Information available to
                                    you in this Micro-site under all applicable laws and regulations
                                    and are otherwise permitted to proceed to the Micro-site; and
                                </li>
                                <li>
                                    no person (including, without limitation, FA, JD, or their
                                    respective directors, employees, agents or advisers) will breach
                                    any applicable law or regulation in connection with your access
                                    to this Micro-site.
                                </li>
                            </ol>
                            <div className="button" onClick={this.handleAcceptTerms.bind(this)}>
                                I agree
                            </div>
                            <div className="button">
                                <Link to="/" title="Go home">
                                    I disagree
                                </Link>
                            </div>
                        </div>
                    </div>
                ) : null}
                {shortname === 'footasylum' ? (
                    <div className={terms ? 'table' : 'table blur'}>
                        <div className="table-row">
                            <div className="table-col header date">Date</div>
                            <div className="table-col header title">Title</div>
                            <div className="table-col header pdf">PDF</div>
                        </div>
                        {data.map((item, key) => {
                            return (
                                <div className="table-row">
                                    <div className="table-col date">{item.date}</div>
                                    <div className="table-col title">{item.title}</div>
                                    <a href={item.url} title={item.title}>
                                        <div className="table-col pdf icon"></div>
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                ) : null}
                {shortname === 'regulatory-news' ? (
                    <iframe
                        title={shortname}
                        allowtransparency="true"
                        marginHeight="0"
                        marginWidth="0"
                        className="responsive full regulatory-news"
                        id="ExternalWebContentExternalIFrame"
                        src="https://otp.tools.investis.com/clients/uk/jdsports3/rns/regulatory-news.aspx?culture=en-GB"
                        frameBorder="0"
                        height="1000"
                        width="100%"
                    ></iframe>
                ) : null}
                {shortname === 'email-alerts' ? (
                    <Fragment>
                        <div class="aboutTopPad"></div>
                        <iframe
                            title={shortname}
                            allowtransparency="true"
                            marginHeight="0"
                            marginWidth="0"
                            className="responsive padded email-alerts"
                            id="ExternalWebContentExternalIFrame"
                            src="https://otp.tools.investis.com/clients/uk/jdsports3/cas/default.aspx?culture=en-GB"
                            frameBorder="0"
                            height="450"
                            width="100%"
                        ></iframe>
                    </Fragment>
                ) : null}
            </Fragment>
        );
    }
}
